// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"EJ-z","carouselContainer":"FJ-z"};